import React, { createContext, useState,  useContext, useEffect} from 'react';
import AccountService from '../services/AccountService';

const accountService = new AccountService();
const AuthContext = createContext();

function AuthProvider({ children }) {

  const [ user, setUser ] = useState({});

  useEffect(() => {
    accountService.getAuthenticatedUser()
    .then(response => setUser(response.data.get_authenticated_user));
  },[user]);

  return (
    <AuthContext.Provider value={{ user } } >
      { children }
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  if(!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };


// WEBPACK FOOTER //
// ./src/hooks/Auth.js